import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

const env = createEnv({
  server: {
    FF_KEY: z.string(),
    NEXT_PREVIEW_TOKEN: z.string(),
    VIMEO_API_KEY: z.string(),
    CENTRA_API_SECRET: z.string(),
    CENTRA_INTEGRATION_TOKEN: z.string(),
    CENTRA_INTEGRATION_URL: z.string().url(),
    STORYBLOK_ACCESS_TOKEN_PREVIEW: z.string(),
    KLAVIYO_PRIVATE_KEY: z.string(),
    KLAVIYO_COMPANY_ID: z.string(),
  },
  client: {
    NEXT_PUBLIC_STORYBLOK_TOKEN: z.string(),
    NEXT_PUBLIC_CENTRA_CHECKOUT_API: z.string(),
    NEXT_PUBLIC_ENV: z.string(),
    NEXT_PUBLIC_API_KEY: z.string(),
    NEXT_PUBLIC_DEPICT_API_URL: z.string(),
    NEXT_PUBLIC_VIDEO_ENDPOINT: z.string().min(1),
    NEXT_PUBLIC_GOOGLE_ANALYTICS_ID: z.string().min(1),
  },
  runtimeEnv: {
    FF_KEY: process.env.FF_KEY,
    NEXT_PREVIEW_TOKEN: process.env.NEXT_PREVIEW_TOKEN,
    VIMEO_API_KEY: process.env.VIMEO_API_KEY,
    CENTRA_API_SECRET: process.env.CENTRA_API_SECRET,
    CENTRA_INTEGRATION_TOKEN: process.env.CENTRA_INTEGRATION_TOKEN,
    CENTRA_INTEGRATION_URL: process.env.CENTRA_INTEGRATION_URL,
    STORYBLOK_ACCESS_TOKEN_PREVIEW: process.env.STORYBLOK_ACCESS_TOKEN_PREVIEW,
    KLAVIYO_PRIVATE_KEY: process.env.KLAVIYO_PRIVATE_KEY,
    KLAVIYO_COMPANY_ID: process.env.KLAVIYO_COMPANY_ID,
    NEXT_PUBLIC_STORYBLOK_TOKEN: process.env.NEXT_PUBLIC_STORYBLOK_TOKEN,
    NEXT_PUBLIC_CENTRA_CHECKOUT_API:
      process.env.NEXT_PUBLIC_CENTRA_CHECKOUT_API,
    NEXT_PUBLIC_ENV: process.env.NODE_ENV,
    NEXT_PUBLIC_API_KEY: process.env.NEXT_PUBLIC_API_KEY,
    NEXT_PUBLIC_DEPICT_API_URL: process.env.NEXT_PUBLIC_DEPICT_API_URL,
    NEXT_PUBLIC_VIDEO_ENDPOINT: process.env.NEXT_PUBLIC_VIDEO_ENDPOINT,
    NEXT_PUBLIC_GOOGLE_ANALYTICS_ID: process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID,
  },
});

export default env;
